// extracted by mini-css-extract-plugin
export default {"container":"userInfo_container__uTKN0","avatar":"userInfo_avatar__Qg+pn","name":"userInfo_name__11A8q"};